var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyWalletIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.6663 7.16406V11.8307C14.6663 12.3612 14.4556 12.8699 14.0806 13.2449C13.7055 13.62 13.1968 13.8307 12.6663 13.8307H3.33301C2.80257 13.8307 2.29387 13.62 1.91879 13.2449C1.54372 12.8699 1.33301 12.3612 1.33301 11.8307V7.16406H14.6663Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6663 3.16406C13.1968 3.16406 13.7055 3.37478 14.0806 3.74985C14.4556 4.12492 14.6663 4.63363 14.6663 5.16406V5.83073H1.33301V5.16406C1.33301 4.63363 1.54372 4.12492 1.91879 3.74985C2.29387 3.37478 2.80257 3.16406 3.33301 3.16406H12.6663ZM11.9997 9.83073H9.99968C9.82286 9.83073 9.6533 9.90097 9.52827 10.026C9.40325 10.151 9.33301 10.3206 9.33301 10.4974C9.33301 10.6742 9.40325 10.8438 9.52827 10.9688C9.6533 11.0938 9.82286 11.1641 9.99968 11.1641H11.9997C12.1765 11.1641 12.3461 11.0938 12.4711 10.9688C12.5961 10.8438 12.6663 10.6742 12.6663 10.4974C12.6663 10.3206 12.5961 10.151 12.4711 10.026C12.3461 9.90097 12.1765 9.83073 11.9997 9.83073Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyWalletIcon);
export default __webpack_public_path__ + "static/media/grey_wallet_icon.501e6fc1e62fae1d2c83629bc68cf812.svg";
export { ForwardRef as ReactComponent };